import { useEffect } from 'react';

// components
import { Anchor, Button, Heading } from '@zillow/constellation';
import LazyLoad from '../LazyLoad';
import {
  StyledBlueWrapper,
  StyledCaption,
  StyledContainer,
  StyledImage,
  StyledImageContainer,
  StyledInline,
  StyledTextContainer,
} from './StyledComponents';

// images
// @ts-ignore
import PaidServices from '../../images/paid-services.png';

// utils
import {
  emitPriceMyRentalViewServicesButtonEvent,
  emitViewPriceMyRentalUpsellEvent,
} from '../../analytics/priceMyRentalEvents';

// hooks
import { useGetUser } from '../../hooks/queries/user';

const TENANT_PLACEMENT_PATH = '/rental-manager/tenant-placement/#?from=price_my_rental';

const DEFAULT_CAPTION = `Zillow’s teamed up with full-service tenant placement partners that cover everything from listing to lease, including getting pricing recommendations. See how you can get more out of leasing your property while finding a qualified tenant at the same time.`;

type Props = {
  customTracking?: () => void;
  captionText?: string;
  ctaText?: string;
  headerText?: string;
  url?: string;
};

const TenantPlacementPromoModule = ({
  customTracking,
  captionText = DEFAULT_CAPTION,
  ctaText = 'Get the details',
  headerText = 'Get professional guidance on how to price your rental',
  url = TENANT_PLACEMENT_PATH,
}: Props) => {
  const { data: user, isLoading, isError } = useGetUser();

  const handleButtonClick = () => {
    if (customTracking) {
      customTracking();
    } else {
      if (!isLoading && !isError) {
        emitPriceMyRentalViewServicesButtonEvent({ user });
      }
    }
  };

  useEffect(() => {
    if (!isLoading && !isError) {
      emitViewPriceMyRentalUpsellEvent({ user });
    }
  }, [isLoading, isError, user]);

  return (
    <StyledBlueWrapper>
      <StyledContainer display="flex" flexDirection={{ default: 'column', lg: 'row' }}>
        <StyledImageContainer>
          <LazyLoad minHeight={375}>
            <StyledImage src={PaidServices} alt="Couple viewing Zillow Rental Manager paid services" />
          </LazyLoad>
        </StyledImageContainer>
        <StyledTextContainer>
          <div>
            <Heading level="4" fontFamily="serif" fontColor="white">
              {headerText}
            </Heading>

            <StyledCaption as="p" fontColor="white">
              {captionText}
            </StyledCaption>

            <StyledInline>
              <Anchor onClick={handleButtonClick} href={url}>
                <Button buttonType="secondary" size="sm" inverse>
                  {ctaText}
                </Button>
              </Anchor>
            </StyledInline>
          </div>
        </StyledTextContainer>
      </StyledContainer>
    </StyledBlueWrapper>
  );
};

export default TenantPlacementPromoModule;
